<template>
  <Card class="layout-card" style="height: 100%">
    <div
      style="
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;
        flex-shrink: 0;
      "
    >
      <div class="search-form">
        <!-- <Input :maxlength="100" v-model="searchForm.bannerId" placeholder="请输入配置ID" /> -->
        <div>
          <Input
            :maxlength="100"
            v-model="searchForm.bannerName"
            placeholder="请输入配置名称"
          />
        </div>
        <div>
          <Select
            v-model="searchForm.langId"
            placeholder="请选择语言"
            style="width: 150px"
          >
            <Option
              v-for="(item, index) in langList"
              :key="index"
              :value="item.id"
              >{{ item.chineseLangName }}</Option
            >
          </Select>
        </div>
        <!-- <DatePicker :editable="false" :value="listDate" style="width:100%" format="yyyy-MM-dd" type="daterange" placeholder="请选择日期" @on-change="getListDate"></DatePicker> -->
        <Button
          type="primary"
          @click="getData()"
          v-if="buttonMenu['/banner/view']"
          >查询</Button
        >
        <Button @click="handleReset()">重置</Button>
      </div>
      <div>
        <Button
          v-if="buttonMenu['/banner/add']"
          type="primary"
          @click="handleOpenEditModal()"
          >添加</Button
        >
      </div>
    </div>
    <div style="height: 100%; overflow: auto">
      <Table :data="tableData" :columns="columns">
        <template #status="{ row }">
          <div>
            <i-switch
              v-if="buttonMenu['/banner/switch/1']"
              :value="!row.bannerStatus"
              :before-change="() => handleChangeStatus(row)"
              @on-change="row.bannerStatus = $event"
            ></i-switch>
            <span v-else>{{ row.bannerStatusName }}</span>
          </div>
        </template>
        <template #imgs="{ row }">
          <div>
            <img
              v-if="row.fileUrl"
              :src="row.fileUrl"
              style="width: 100%; cursor: pointer"
              @click="$viewerApi({ images: [row.fileUrl] })"
            />
          </div>
        </template>
        <template #action="{ row }">
          <div>
            <a
              style="margin-left: 10px"
              v-if="buttonMenu['/banner/edit']"
              @click="handleOpenEditModal(row)"
              >编辑</a
            >
            <Poptip
              confirm
              v-if="buttonMenu['/banner/delete']"
              title="确定要删除吗？"
              transfer
              @on-ok="handleDel(row)"
              ><a style="margin-left: 10px; color: red">删除</a></Poptip
            >
          </div>
        </template>
        <Pages slot="footer" :page="page" :func="getData"></Pages>
      </Table>
    </div>
    <Modal
      v-model="editVisible"
      :title="(form.id ? '编辑' : '新增') + 'banner'"
    >
      <Form
        @submit.native.prevent
        :label-width="100"
        v-if="editVisible"
        :model="form"
        ref="formRef"
      >
        <FormItem
          label="配置名称："
          prop="bannerName"
          :rules="[{ required: true, message: '请输入配置名称' }]"
        >
          <Input :maxlength="100" v-model="form.bannerName" />
        </FormItem>
        <FormItem
          label="图片："
          prop="fileId"
          :rules="[{ required: true, message: '请上传图片' }]"
        >
          <!-- <Upload v-model="form.fileId" /> -->
          <div>
            <UploadFile
              :uploadList="form.fileUrl ? [form.fileUrl] : []"
              @hanldDel="
                form.fileId = ''
                form.fileUrl = ''
              "
              @handleSuccess="
                $set(form, 'fileId', $event.fileId)
                $set(form, 'fileUrl', $event.fileUrl)
              "
            >
            </UploadFile>
            <!-- <div v-if="form.fileUrl" style="cursor:pointer;" @click="$viewerApi({images:[form.fileUrl]})">
                          {{ form.fileUrl.split('/').at(-1) }}
                        </div> -->
          </div>
        </FormItem>
        <FormItem
          label="颜色："
          prop="bannerColor"
          :rules="[{ required: true, message: '请选择颜色' }]"
        >
          <div style="display: flex">
            <input type="color" v-model="form.bannerColor" />
            <Button
              v-if="form.fileUrl"
              style="margin-left: 10px"
              type="primary"
              @click="handleTest"
              >预览取色</Button
            >
          </div>
        </FormItem>
        <FormItem
          label="所属语言："
          prop="langId"
          :rules="[{ required: true, message: '请选择所属语言' }]"
        >
          <Select
            v-model="form.langId"
            placeholder="请选择语言"
            @on-change="
              (e) => {
                if (e) {
                  $refs.searchMode.getData({ langId: e }, [
                    {
                      typeName: '首页',
                      id: -1
                    }
                  ])
                  $set(form, 'typeIds', null)
                }
              }
            "
          >
            <Option
              v-for="(item, index) in langList"
              :key="index"
              :value="item.id"
              >{{ item.chineseLangName }}</Option
            >
          </Select>
        </FormItem>
        <FormItem
          label="分类"
          prop="typeIds"
          :rules="[{ required: true, message: '请选择分类' }]"
        >
          <search
            v-model="form.typeIds"
            :api="{ url: getTypeList }"
            :selectProp="{
              filterable: true,
              disabled: !form.langId,
              multiple: true
            }"
            extraKey="typeName"
            :keys="{ key: 'typeNameCn', value: 'id' }"
            ref="searchMode"
          ></search>
        </FormItem>
        <FormItem
          label="排序值："
          prop="bannerSort"
          :rules="[{ required: true, message: '请输入排序值' }]"
        >
          <InputNumber :min="0" v-model="form.bannerSort" :max="99999" />
        </FormItem>

        <FormItem
          label="跳转类型："
          prop="bannerType"
          :rules="[{ required: true, message: '请选择跳转类型' }]"
        >
          <Select v-model="form.bannerType" @on-change="form.bannerTarget = ''">
            <Option :value="0">短剧</Option>
            <Option :value="1">H5内部链接</Option>
            <Option :value="2">H5外部链接</Option>
          </Select>
        </FormItem>
        <FormItem
          label="跳转目标："
          prop="bannerTarget"
          required
          :rules="[
            {
              validator: (rule, value, callback) => {
                if (!form.bannerTarget) {
                  callback('请输入跳转目标')
                } else {
                  callback()
                }
              }
            }
          ]"
        >
          <playSearch
            v-if="form.bannerType === 0"
            v-model="form.bannerTarget"
            :name="form.playName"
          ></playSearch>
          <Input
            type="textarea"
            :autosize="{ minRows: 3 }"
            show-word-limit
            :maxlength="120"
            v-else
            v-model="form.bannerTarget"
            placeholder="请输入链接地址"
          />
        </FormItem>
      </Form>
      <template #footer>
        <Button @click="editVisible = false">取消</Button>
        <Button type="primary" :loading="submitLoading" @click="handleSubmit()"
          >提交</Button
        >
      </template>
    </Modal>
    <Modal v-model="showPicker" footer-hide :width="1000">
      <img :src="form.fileUrl" style="width: 100%" />

      <Button type="primary" @click="handleOpenColorPicker" style="width: 100%"
        >点击取色</Button
      >
    </Modal>
    <!-- <Button type="primary" v-if="showPicker" style="position: fixed;top:20px; left:50%;transform:translate(-50%,0);z-index: 10001;" @click="handleOpenColorPicker">取色</Button> -->
  </Card>
</template>

<script>
import Pages from '@/components/pages'
import {
  getBannerList,
  addBanner,
  delBanner,
  editBanner,
  getBannerInfo,
  changeBannerStatus
} from '@/api/banner'
import vueColorPickerMin from 'vue-color-picker'
import UploadFile from '@/components/Upload/uploadImg.vue'
import search from '@/components/searchMode'
import { getLangList } from '../../api/lang'
import playSearch from '@/components/playSearch'
import { getTypeList } from '@/api/channel'
import { Message } from 'view-design'
export default {
  components: {
    Pages,
    vueColorPickerMin,
    UploadFile,
    playSearch,
    search
  },
  data() {
    return {
      editVisible: false,
      form: {},
      showPicker: false,
      searchForm: {},
      getTypeList,
      langList: [],
      listDate: [],
      submitLoading: false,
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      tableData: [],
      columns: [
        // {
        //   title: '配置id',
        //   key: 'id'
        // },
        {
          title: '配置名称',
          key: 'bannerName'
        },
        {
          title: '图片',
          key: 'fileId',
          align: 'center',
          width: 150,
          slot: 'imgs'
        },
        {
          title: '所属语言',
          align: 'center',
          key: 'langName'
        },
        {
          title: '所属分类',
          key: 'typeNames'
        },
        {
          title: '颜色',
          align: 'center',
          key: 'bannerColor',
          render: (h, params) => {
            return h('div', {
              style: {
                width: '20px',
                height: '20px',
                backgroundColor: params.row.bannerColor,
                margin: '0 auto'
              }
            })
          }
        },
        {
          title: '排序值',
          align: 'center',
          key: 'bannerSort'
        },
        {
          title: '跳转类型',
          align: 'center',
          key: 'bannerTypeName'
        },
        {
          title: '跳转目标',
          align: 'center',
          key: 'bannerTarget'
        },
        {
          title: '状态',
          align: 'center',
          slot: 'status'
        },
        // {
        //   title: '登记时间',
        //   key: 'updateTime'
        // },
        {
          title: '操作',
          align: 'center',
          slot: 'action'
        }
      ]
    }
  },
  computed: {
    buttonMenu() {
      const li = this.$store.getters.getMenuRules('server/banner')
      const obj = {}
      li.forEach((i) => {
        obj[i.menuPath] = true
      })
      return obj
    }
  },
  methods: {
    handleTest(e) {
      this.showPicker = true
      // document.querySelector('.viewer-close').addEventListener('click',()=>{
      //   this.showPicker = false
      // })
      // document.querySelector('.viewer-canvas').addEventListener('click',()=>{
      //   this.showPicker = false
      // })
      // const a = setTimeout(() => {
      //   document.querySelector('.viewer-canvas').children[0].addEventListener('click',(e)=>{
      //     e.preventDefault();
      //       e.stopPropagation();
      //   })
      //   clearTimeout(a)
      // }, 500);
    },
    handleOpenColorPicker(e) {
      if (!window.EyeDropper) {
        this.$Message.error('您的浏览器不支持取色器功能')
        return
      }
      const eyeDropper = new window.EyeDropper()
      eyeDropper.open().then((r) => {
        this.form.bannerColor = r.sRGBHex
        this.showPicker = false
      })
    },
    getData(page) {
      if (page) this.page.current = page
      else this.page.current = 1
      getBannerList({
        ...this.page,
        ...this.searchForm
      }).then(({ data }) => {
        this.tableData = data.records
        this.page.current = data.current
        this.page.total = data.total
      })
    },
    handleChangeStatus(row) {
      changeBannerStatus(row.id)
        .then((r) => {
          this.$Message.success('操作成功')
          this.getData(this.page.current)
        })
        .catch((e) => {
          this.$Message.error('操作失败')
        })
      return new Promise(() => {})
    },
    handleGetLang() {
      getLangList({
        current: -1,
        size: -1
        // , langStatus: true
      }).then((r) => {
        this.langList = r.data.records
      })
    },
    async handleOpenEditModal(row) {
      this.form = {
        bannerSort: 0
      }
      if (row) {
        const r = await getBannerInfo(row.id)
        this.form = r.data
      }
      this.editVisible = true
      this.$nextTick(() => {
        if (this.form.id) {
          this.$refs.searchMode.getData({ langId: this.form.langId }, [
            {
              typeName: '首页',
              id: -1
            }
          ])
        }
      })
    },
    getListDate(data) {
      this.listDate = data
      this.searchForm.startDate = data[0]
      this.searchForm.endDate = data[1]
    },
    handleSubmit() {
      this.$refs.formRef.validate((r) => {
        if (r) {
          const func = this.form.id ? editBanner : addBanner
          this.submitLoading = true
          func({
            ...this.form
          })
            .then((r) => {
              this.$Message.success('操作成功')
              this.getData()
              this.submitLoading = false
              this.editVisible = false
            })
            .catch(() => {
              this.submitLoading = false
            })
        }
      })
    },
    handleDel(row) {
      delBanner(row.id).then((r) => {
        this.$Message.success('操作成功')
        this.getData()
      })
    },
    handleReset() {
      this.searchForm = {}
    }
  },
  mounted() {
    this.getData()
    this.handleGetLang()
  }
}
</script>

<style scoped lang="less">
.search-form {
  display: flex;
  & > * {
    margin: 0 5px;
  }
}
.layout-card {
  /deep/ .ivu-card-body {
    height: 100%;
    display: flex;
    flex-direction: column;
  }
}
</style>
